import Header from './components/Header';
import HeroSection from './components/HeroSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import FaqSection from './components/FaqSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <CommentsSection />
        <AboutSection />
        <AppSection />
        <RankingSection />
        <ContactSection />
        <TopicsSection />
        <MediaSection />
        <FaqSection />
        <CarouselSection />
        <IndexSection />
        <CardsSection />
        <UpdatesSection />
        <FeaturesSection />
      </main>
      <Footer />
    </>
  );
}